import { ApiClient } from './api-client';
import { ApiSourceEnum } from './api-client/dtos';

export const authApi = new ApiClient(ApiSourceEnum.API_AUTH);
export const unauthApi = new ApiClient(ApiSourceEnum.API_UNAUTH);
